import { CradleCommands } from '../constants/constants';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import {
  Day,
  OccurenceTypes,
  RingPattern,
  RingPatterns,
  ScheduledRing,
} from '../constants/constants';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Utils } from '../constants/utils';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { CradleService } from '../services/cradle.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AudioService } from '../services/audio.service';
import cloneDeep from 'lodash-es/cloneDeep';

@Component({
    selector: 'app-ring-patterns',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        FormsModule,
        MatSelectModule,
        MatInputModule,
        MatDialogModule,
        MatFormFieldModule,
    ],
    templateUrl: './ring-patterns.component.html',
    styleUrl: './ring-patterns.component.scss'
})
export class RingPatternsComponent implements OnInit {
  ringPatterns: RingPatterns = {};
  ringPatternArr: RingPattern[] = [];
  ringScheduleMap: {[key:string]:ScheduledRing} = {};
  dismissLoaderTimout: any;

  patternTblColumns: string[] = [
    'id',
    'name',
    'patternCol',
    'count',
    'icon',
    'actions',
  ];
  isEditing: boolean = false;
  patternsGettingEdited: RingPatterns = {};
  constructor(
    private dataService: DataService,
    private matDialog: MatDialog,
    private cradleService: CradleService,
    private snackBar: MatSnackBar,
    private audioService: AudioService
  ) {}
  ngOnInit() {

    this.dataService.ringPatterns.subscribe((r) => {
      if(r){
        this.ringPatterns = r;
        this.ringPatternArr = Utils.dictToList(r);
        this.dismissLoader();
      }
    });
    this.dataService.scheduledRings.subscribe((sch) => {
      if(sch){
         this.ringScheduleMap = sch.reduce((ringScheduleMap: any, sch)=>{
          ringScheduleMap[sch.pattern] = sch;
          return ringScheduleMap
         },{});
      }
    });
    this.cradleService.dispatchCommand(CradleCommands.GET_RING_PATTERNS);
  }

  updateRingPattern(ringPattern: RingPattern) {
    if (ringPattern.isFirstEdit) {
      const duplicateId = this.ringPatterns[ringPattern.id];
      if (duplicateId) {
        this.snackBar.open(
          `There is already another pattern with same id ${ringPattern.id}. Please select another ID for the new pattern`,
          'Ok'
        );
        return;
      }
    }
    if (!ringPattern.id) {
      this.snackBar.open(
        'Please enter a valid ID for pattern ' + ringPattern.id, 'Ok'
      );
      return;
    }
    if (!ringPattern?.name)
     {
      this.snackBar.open(
        'Please enter valid name for pattern ' + ringPattern.id, 'Ok'
      );
      return;
    }
    if (!(ringPattern.pattern && ringPattern.pattern.length > 0) || ringPattern.pattern.some(p=>!(p && p>0))) {
      this.snackBar.open(
        'Please enter valid intervals between rings for the pattern ' + ringPattern.id, 'Ok'
      );
      return;
    }
    if (!(ringPattern.count && ringPattern.count>0)) {
      this.snackBar.open(
        'Please enter a valid number as maximum count of rings for the pattern' +
          ringPattern.id, 'Ok'
      );
      return;
    }

    ringPattern.isEditing = false;
    ringPattern.isFirstEdit = false;
    delete ringPattern.isEditing;
    delete ringPattern.isFirstEdit;
    console.log(ringPattern);
    this.cradleService.dispatchCommand(
      CradleCommands.UPDATE_RING_PATTERN,
      ringPattern
    );
    this.showLoaderWithTimout();
  }

  deletePattern(pattern: RingPattern) {
    if(this.ringScheduleMap && this.ringScheduleMap[pattern.id]){
      const sch = this.ringScheduleMap[pattern.id];
      this.snackBar.open(`Schedule \"${sch.id}\" uses this pattern. Please delete all the schedules that are using the pattern ${pattern.name} before deleting the pattern.`, 'Ok')
      return;
    }
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      data: {
        msg: `Are you sure you want to remove pattern ${
          pattern.id
        } - ${pattern.name}?`,
        title: 'Confirm Delete Pattern',
        confirmLabel: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe((deleteConfirmed) => {
      if (deleteConfirmed) {
        this.cradleService.dispatchCommand(
          CradleCommands.DELETE_RING_PATTERN,
          pattern.id
        );
        this.showLoaderWithTimout();
        console.log('delete pattern confirmed');
      }
    });
  }

  addNewPattern() {
    this.ringPatternArr = [...this.ringPatternArr, new RingPattern()];
  }

  addNewInterval(pattern:number[]){
    if(!pattern){
      pattern = []
    }
    pattern.push(null)
  }
  deleteInterval(pattern: number[], deleteIndex?: number){
    // pattern.splice(deleteIndex,1);
    pattern.pop();
  }

  startEditing(pattern:RingPattern){
    this.patternsGettingEdited[pattern.id] = cloneDeep(pattern);
    pattern.isEditing = true;
  }

  cancelEditing(pattern:RingPattern){
    if(this.patternsGettingEdited[pattern.id]){
      const pIdx = this.ringPatternArr.findIndex(p=>p.id==pattern.id);
      const uneditedPattern = this.patternsGettingEdited[pattern.id];
      uneditedPattern.isEditing = false;
      this.ringPatternArr[pIdx] = uneditedPattern;
    }else {
      const pIdx = this.ringPatternArr.findIndex(s=>s.id==pattern.id);
      this.ringPatternArr.splice(pIdx,1);
    }
    this.ringPatternArr = [...this.ringPatternArr];
  }

  trackByIndex(index:number, item: any):number{
    return index;
  }

  showLoaderWithTimout(){
    this.dataService.isLoading.next(true);
    this.dismissLoaderTimout = setTimeout(()=>{
      if(this.dataService.isLoading.value){
        this.dataService.isLoading.next(false);
        this.snackBar.open('Request timed out', 'Ok');
        this.cradleService.dispatchCommand(CradleCommands.GET_SCHEDULED_RINGS);
      }
    },5000);
  }

  dismissLoader(){
    this.dataService.isLoading.next(false);
    clearTimeout(this.dismissLoaderTimout);
  }

  async playPattern(pattern: RingPattern){
    console.log('Playing pattern:', pattern.name, 'with intervals:', pattern.pattern);
    
    if (!pattern.pattern || pattern.pattern.length === 0) {
      this.snackBar.open('No intervals defined for this pattern', 'Ok');
      return;
    }

    // Validate pattern intervals
    const validIntervals = pattern.pattern.filter(interval => interval && interval > 0);
    if (validIntervals.length === 0) {
      this.snackBar.open('Pattern contains no valid intervals', 'Ok');
      return;
    }

    try {
      // Show feedback that pattern is playing
      this.snackBar.open(`Playing pattern: ${pattern.name}`, 'Ok', { duration: 2000 });
      
      // Play the bell pattern with the defined intervals
      await this.audioService.playBellPattern(pattern.pattern);
      
      // Optional: Show completion message
      console.log('Pattern playback completed');
    } catch (error) {
      console.error('Error playing pattern:', error);
      this.snackBar.open('Error playing bell pattern', 'Ok');
    }
  }
}
